/* eslint-disable react/jsx-props-no-spreading */

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import { useTranslation } from 'react-i18next';

import '../scss/drag-and-drop.scss';
import { ReactComponent as DragIcon } from '../../../assets/icons/drag-icon.svg';
import CustomInput from '../../../shared-components/custom-input/CustomInput';
import CustomSwitchButton from '../../../shared-components/custom-switch-button/custom-switch-button';
import SelectField from '../../../shared-components/select-field/SelectField';

/**
 * Handling Drag and Drop
 * @param param0
 * @returns
 */
function DragAndDrop({ id, values, handleChange, serialNumbersToDownload }: any) {
  const { t } = useTranslation('qrCode');
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  const style = { transition, transform: CSS.Transform.toString(transform) };

  return (
    <div className="drag-wrap" key={id} ref={setNodeRef} style={style}>
      {values.key === 'qr-code' ? (
        <div className="qr-element">
          <div className="icon" {...listeners} {...attributes}>
            <DragIcon />
          </div>
          <p className="qr-text">{t('qrCode')}</p>
        </div>
      ) : (
        <div className="dragger-container">
          <div className="drag-icon">
            <span {...listeners} {...attributes}>
              <DragIcon />
            </span>
            <p>{t(values.key)}</p>
          </div>
          <div className="inputs-container">
            <div className="input">
              {values.editingText && values.key !== 'SN' ? (
                <CustomInput
                  name={`${values.key}/text`}
                  value={values.text}
                  onChangeValue={handleChange}
                  type="text"
                  placeholder={t('sampleText')}
                  handleBlur={(name: string) =>
                    handleChange(`${values.key}/editingText/${name}`, false)
                  }
                  autoFocus
                />
              ) : (
                <p
                  role="presentation"
                  onClick={() => handleChange(`${values.key}/editingText`, true)}>
                  {values.key === 'SN' ? serialNumbersToDownload[0] || values.text : values.text}
                </p>
              )}
            </div>
            <div className="drop-down">
              <SelectField
                name={`${values.key}/fontFamily`}
                selectedValue={values.fontFamily || ''}
                placeholder={t('fontFamily')}
                onChangeValue={handleChange}
                options={[
                  {
                    label: t('inter'),
                    value: 'Inter',
                  },
                  {
                    label: t('arial'),
                    value: 'Arial',
                  },
                  {
                    label: t('verdana'),
                    value: 'Verdana',
                  },
                ]}
              />
              <SelectField
                name={`${values.key}/fontSize`}
                selectedValue={values.fontSize || ''}
                placeholder={t('fontSize')}
                onChangeValue={handleChange}
                options={[
                  {
                    label: '16',
                    value: '16',
                  },
                  {
                    label: '18',
                    value: '18',
                  },
                  {
                    label: '22',
                    value: '22',
                  },
                  {
                    label: '26',
                    value: '26',
                  },
                ]}
              />
              <CustomSwitchButton
                checked={values.display}
                change={(checked: boolean) => handleChange(`${values.key}/display`, checked)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DragAndDrop;
